define([
  "marionette",
  "jquery",
  "messaging/messenger",
  "configuration/properties",
  "./template/taskWizardTemplatePageTemplate.html",
], function (Marionette, $, Messenger, Properties, TaskWizardTemplatePageTemplate) {
  "use strict";

  var TaskWizardTemplatePageView = {};

  TaskWizardTemplatePageView.templatePageView = Marionette.ItemView.extend({
    className: "form-horizontal",
    template: TaskWizardTemplatePageTemplate,
    triggers: {
      "input .task-save-as-template": "change:template",
    },
    ui: {
      taskDescription: ".task-description",
      taskDescriptionError: ".task-description-error",
      taskName: ".task-name",
      taskNameError: ".task-name-error",
      taskSaveAsTemplate: ".task-save-as-template",
      templateDescription: ".task-template-description",
      templateDescriptionError: ".task-template-description-error",
      templateName: ".task-template-name",
      templateNameError: ".task-template-name-error",
    },
    clearErrors: function () {
      this.ui.taskDescriptionError.html("");
      this.ui.taskNameError.html("");
      this.ui.templateDescriptionError.html("");
      this.ui.templateNameError.html("");
    },
    descriptionError: function (message) {
      this.ui.taskDescriptionError
        .html('<h5 class="error-message">' + message + "</h5>")
        .hide()
        .fadeIn();
    },
    nameError: function (message) {
      this.ui.taskNameError
        .html('<h5 class="error-message">' + message + "</h5>")
        .hide()
        .fadeIn();
    },
    disableTemplateFields: function () {
      this.ui.templateName.prop("disabled", true);
      this.ui.templateDescription.prop("disabled", true);
    },
    enableTemplateFields: function () {
      this.ui.templateName.prop("disabled", false);
      this.ui.templateDescription.prop("disabled", false);
    },
    getTaskDescription: function () {
      var value = this.ui.taskDescription.val();
      var trimmedValue = value.trim();
      if (value != trimmedValue) {
        this.ui.taskDescription.val(trimmedValue);
      }
      return trimmedValue;
    },
    getTaskName: function () {
      var value = this.ui.taskName.val();
      var trimmedValue = value.trim();
      if (value != trimmedValue) {
        this.ui.taskName.val(trimmedValue);
      }
      return trimmedValue;
    },
    getTemplateDescription: function () {
      var value = this.ui.templateDescription.val();
      var trimmedValue = value.trim();
      if (value != trimmedValue) {
        this.ui.templateDescription.val(trimmedValue);
      }
      return trimmedValue;
    },
    getTemplateName: function () {
      var value = this.ui.templateName.val();
      var trimmedValue = value.trim();
      if (value != trimmedValue) {
        this.ui.templateName.val(trimmedValue);
      }
      return trimmedValue;
    },
    isTemplate: function () {
      return this.ui.taskSaveAsTemplate.prop("checked");
    },
    templateDescriptionError: function (message) {
      this.ui.templateDescriptionError
        .html('<h5 class="error-message">' + message + "</h5>")
        .hide()
        .fadeIn();
    },
    templateNameError: function (message) {
      this.ui.templateNameError
        .html('<h5 class="error-message">' + message + "</h5>")
        .hide()
        .fadeIn();
    },
  });

  return TaskWizardTemplatePageView;
});
